<template>
    <div class="row">
        <div class="col-xl-8 d-flex">
            <CurrentTariffCard
                v-if="project"
                :tariff="project.tariff"
                :tariff-expired-at="project.tariff_expired_date"
                :products-count="totalProductsCount"
                :integrations-count="totalIntegrationsCount"
                :format-number="formatNumber"
            />
        </div>
        <div class="col-xl-4 d-flex">
            <AiBalanceCard
                :format-number="formatNumber"
            />
        </div>
    </div>
    <PaymentHistoryCard />
</template>
<script>
import CurrentTariffCard from './cards/CurrentTariffCard.vue';
import AiBalanceCard from './cards/AiBalanceCard.vue';
import PaymentHistoryCard from './cards/PaymentHistoryCard.vue';

import { httpClient } from '../../../../services/HttpClient';

export default {
    name: "IndexTariffsPage",
    components: {
        CurrentTariffCard, AiBalanceCard, PaymentHistoryCard
    },
    data() {
        return {
            project: null,
            totalProductsCount: 0,
            totalIntegrationsCount: 0
        }
    },
    methods: {
        formatNumber(num) {
            const rounded = parseFloat(parseFloat(num).toFixed(2));
            const formatted = rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            return formatted;
        },
        async fetchProject() {
            await httpClient.get(`/projects/${this.$route.params.projectUuid}`).then((response) => {
                this.project = response.data.data;
            })
        },
        fetchTotalProductsCount() {
            httpClient.get(`/catalog/product-items`, {
                limit: 1
            }).then((response) => {
                this.totalProductsCount = response.data.meta.total;
            })
        },
        fetchTotalIntegrationsCount() {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/pim/channels`, {
                limit: 1
            }).then((response) => {
                this.totalIntegrationsCount = response.data.meta.total;
            })
        }
    },
    async mounted() {
        await this.fetchProject();
        this.fetchTotalProductsCount();
        this.fetchTotalIntegrationsCount();
    },
}
</script>
